export const ShowChoice = ({ setOptionsType = () => {} }) => {
  return (
    <div className="choices--start">
      <button
        className="gcds--button button--secondary"
        onClick={() => setOptionsType('start-from-scratch')}
      >
        <span className="button--label">Start from scratch</span>
      </button>

      <p>or</p>

      <button
        className="gcds--button button--secondary"
        onClick={() => setOptionsType('edit-common-list')}
      >
        <span className="button--label">Edit a common list</span>
      </button>
    </div>
  )
}
